import type { MessageKey } from "@wato/i18n";
import type { LabelRef } from "../api/types";

/** System-managed labels are stored under a fixed English name; map them to catalog keys. */
const SYSTEM_LABEL_KEYS: Readonly<Record<string, MessageKey>> = {
  "Delivery failed": "contacts.labels.system.deliveryFailed",
};

type Translate = (key: MessageKey) => string;

/** FB3-30: the name to render for a label (localised for system-managed labels). */
export function labelDisplayName(
  label: Pick<LabelRef, "name"> & { readonly system?: boolean },
  t: Translate,
): string {
  const cls = /^class:(serious_buyer|just_asking|complaint|vip)$/u.exec(label.name);
  if (cls) return t(`customerClass.${cls[1]}` as MessageKey);
  const key = SYSTEM_LABEL_KEYS[label.name];
  return key && label.system !== false ? t(key) : label.name;
}
